import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
// FIX 1: Import useNavigate and remove unused NavLink and useLocation.
import { useNavigate } from "react-router-dom"; 
// FIX 2: Removed unused Helmet import.
import ReCAPTCHA from "react-google-recaptcha";
import toast from "react-hot-toast";
import countryCodesData from "../../Components/countryCodes.json"; // Import the JSON file
// FIX 3: Removed unused MUI component imports.

// Framer motion animation settings for heading
const headingVariants = {
  hidden: { opacity: 0, x: 50 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.1,
      type: "spring",
      stiffness: 120,
    },
  }),
};

const headingText = "Register here";

const RegisterForm = () => {
  const [countryCodes, setCountryCodes] = useState([]);

  useEffect(() => {
    setCountryCodes(countryCodesData); // Load country codes from JSON
  }, []);
  const [formData, setFormData] = useState({
    titleid: "1",
    fullname: "",
    countryCode: "+44",
    phoneNo: "",
    email: "",
    companyName: "",
    reCaptcha: "",
  });

  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate(); // This line will now work correctly.

  // Live field validation for submit button state
  useEffect(() => {
    const nameRegex = /^[A-Za-z\s]+$/;
    const phoneRegex = /^[0-9]{8,15}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const zeroCount = (formData.phoneNo.match(/0/g) || []).length;

    const isValid =
      formData.titleid &&
      formData.fullname &&
      nameRegex.test(formData.fullname) &&
      formData.phoneNo &&
      phoneRegex.test(formData.phoneNo) &&
      zeroCount <= 3 &&
      formData.email &&
      emailRegex.test(formData.email) &&
      formData.companyName &&
      formData.reCaptcha;

    setIsFormValid(isValid);
  }, [formData]);

  const validateForm = () => {
    const newErrors = {};
    const nameRegex = /^[A-Za-z\s]+$/;
    const phoneRegex = /^[0-9]{8,15}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.titleid) newErrors.titleid = "Title is required";

    if (!formData.fullname) {
      newErrors.fullname = "Full Name is required.";
    } else if (!nameRegex.test(formData.fullname)) {
      newErrors.fullname = "Full Name should contain only letters and spaces.";
    }

    if (!formData.phoneNo) {
      newErrors.phoneNo = "Phone No is required.";
    } else if (!phoneRegex.test(formData.phoneNo)) {
      newErrors.phoneNo = "Phone No must be 8–15 digits and numbers only.";
    } else if ((formData.phoneNo.match(/0/g) || []).length > 3) {
      newErrors.phoneNo = "Phone No cannot contain more than three zeros.";
    }

    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (!formData.companyName)
      newErrors.companyName = "Company Name is required.";

    if (!formData.reCaptcha)
      newErrors.reCaptcha = "Please verify that you are not a robot.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setSubmitMessage({
        type: "error",
        text: "Please fill all the form fields correctly.",
      });
      return false;
    }

    return true;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleNameKeyPress = (e) => {
    if (!/^[A-Za-z\s]*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handlePhoneKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleReCaptcha = (value) => {
    setFormData((prev) => ({ ...prev, reCaptcha: value }));
    setErrors((prev) => ({ ...prev, reCaptcha: "" }));
  };

  const trimFormData = (data) => {
    const trimmedData = {};
    Object.keys(data).forEach((key) => {
      const value = data[key];
      trimmedData[key] = typeof value === "string" ? value.trim() : value;
    });
    return trimmedData;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting || !isFormValid) return;
    if (!validateForm()) return;

    window.grecaptcha?.reset();
    setIsSubmitting(true);

    let toastId;
    try {
      toastId = toast.loading(<b>Saving...</b>);
      const trimmedFormData = trimFormData(formData);

      const response = await axios.post(
        "https://msbassociationuk.org/prod/api/msb/savewebinarregistration",
        trimmedFormData
      );

      toast.dismiss(toastId);

      if (response.data.response && response.data.responseCode === "00") {
        toast.success(<b>Form submitted successfully!</b>);
        setSubmitMessage({
          type: "success",
          text: "Form submitted successfully!",
        });

        setTimeout(() => {
          navigate("/eventsdetails");
        }, 1000);

        setFormData({
          titleid: "1",
          fullname: "",
          countryCode: "+44",
          phoneNo: "",
          email: "",
          companyName: "",
          reCaptcha: "",
        });
        setErrors({});
      } else {
        const msg =
          response.data.data || "Something went wrong. Please try again.";
        toast.error(msg);
        setSubmitMessage({ type: "error", text: msg });
      }
    } catch (error) {
      toast.dismiss(toastId);
      const msg =
        error.response?.data?.data || "Something went wrong. Please try again.";
      toast.error(msg);
      setSubmitMessage({ type: "error", text: msg });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (submitMessage) {
      const timer = setTimeout(() => setSubmitMessage(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [submitMessage]);

  return (
    <>
      <div className="row justify-content-center" id="webinarRegisterForm">
        <div className="col-lg-12 col-md-12 col-12">
          <div
            className="p-4"
            style={{ background: "#efefef", borderRadius: "15px" }}
          >
            <div className="heading_block text-center">
              <h3 className="heading_text">
                {headingText.split("").map((char, i) => (
                  <motion.span
                    key={`${char}-${i}`}
                    custom={i}
                    initial="hidden"
                    animate="visible"
                    variants={headingVariants}
                  >
                    {char}
                  </motion.span>
                ))}
              </h3>
              <p className="heading_description mb-0">
                Please fill in below information to book your spot
              </p>
            </div>

            <div className="event-card2">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                  <form onSubmit={handleSubmit}>
                    <div className="row mt-2">
                      {/* Title */}
                      <div className="col-md-2 col-12">
                        <div className="form-group">
                          <label
                            className="input_title mt-3"
                            htmlFor="titleid"
                          >
                            Title<sup>*</sup>
                          </label>
                          <select
                            id="titleid"
                            className={`form-control select-arrow ${
                              errors.titleid ? "bg-danger text-white" : ""
                            }`}
                            name="titleid"
                            value={formData.titleid}
                            onChange={handleInputChange}
                          >
                            {[
                              { label: "Mr.", value: "1" },
                              { label: "Mrs.", value: "2" },
                              { label: "Miss", value: "3" },
                              { label: "Dr.", value: "4" },
                            ].map((title) => (
                              <option key={title.value} value={title.value}>
                                {title.label}
                              </option>
                            ))}
                          </select>
                          {errors.titleid && (
                            <span className="text-danger">
                              {errors.titleid}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Full Name */}
                      <div className="col-md-10">
                        <div className="form-group">
                          <label
                            className="input_title mt-3"
                            htmlFor="fullname"
                          >
                            Full Name<sup>*</sup>
                          </label>
                          <input
                            id="fullname"
                            className={`form-control ${
                              errors.fullname ? "bg-danger" : ""
                            }`}
                            type="text"
                            name="fullname"
                            value={formData.fullname}
                            onChange={handleInputChange}
                            onKeyPress={handleNameKeyPress}
                          />
                          {errors.fullname && (
                            <span className="text-danger">
                              {errors.fullname}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Phone */}
                      <div className="col-md-12 mt-3">
                        <div className="form-group">
                          <label className="input_title" htmlFor="phoneNo">
                            Phone<sup>*</sup>
                          </label>
                          <div className="input-group">
                            <select
                              id="countryCode"
                              className="form-control select-arrow p-3"
                              name="countryCode"
                              style={{ maxWidth: "150px" }}
                              value={formData.countryCode}
                              onChange={handleInputChange}
                            >
                              {/* FIX 4: Removed the duplicate map function */}
                              {countryCodes.map((country) => (
                                <option key={country.code} value={country.code}>
                                  {country.code} ({country.name})
                                </option>
                              ))}
                            </select>
                            <input
                              className={`form-control ${
                                errors.phoneNo ? "bg-danger" : ""
                              }`}
                              type="text"
                              name="phoneNo"
                              value={formData.phoneNo}
                              onChange={handleInputChange}
                              onKeyPress={handlePhoneKeyPress}
                            />
                          </div>
                          {errors.phoneNo && (
                            <span className="text-danger">
                              {errors.phoneNo}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Email */}
                      <div className="col-md-12 mt-3">
                        <div className="form-group">
                          <label className="input_title" htmlFor="email">
                            Email<sup>*</sup>
                          </label>
                          <input
                            id="email"
                            className={`form-control ${
                              errors.email ? "bg-danger" : ""
                            }`}
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                          {errors.email && (
                            <span className="text-danger">
                              {errors.email}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Company Name */}
                      <div className="col-md-12 mt-3">
                        <div className="form-group">
                          <label
                            className="input_title"
                            htmlFor="companyName"
                          >
                            Company Name<sup>*</sup>
                          </label>
                          <input
                            id="companyName"
                            className={`form-control ${
                              errors.companyName ? "bg-danger" : ""
                            }`}
                            type="text"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleInputChange}
                          />
                          {errors.companyName && (
                            <span className="text-danger">
                              {errors.companyName}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* reCAPTCHA */}
                      <div className="col-md-12 mt-3">
                        <ReCAPTCHA
                          sitekey="6LfmsZoqAAAAAPQgbaeEuX7w8IZxz7Ncqgs2i0hY"
                          onChange={handleReCaptcha}
                          onErrored={() =>
                            setErrors((prev) => ({
                              ...prev,
                              reCaptcha: "Captcha verification failed.",
                            }))
                          }
                        />
                        {errors.reCaptcha && (
                          <span className="text-danger">
                            {errors.reCaptcha}
                          </span>
                        )}
                      </div>

                      {/* Submit Button */}
                      <div className="col-md-12">
                        <div className="text-center mt-3 mb-3">
                          <button
                            type="submit"
                            className="btn btn-primary btn-lg w-100"
                            disabled={!isFormValid || isSubmitting}
                          >
                            {isSubmitting ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                  <img
                    src="assets/images/event-banner/icon.png"
                    alt="Registration Form"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterForm;